import React, { useRef, useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Layout from '../../Components/Layout';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import toast from 'react-hot-toast';
import logo from '../../Assets/ems logo.png';
import axios from 'axios';

const SalarySlipPdf = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const salaryRef = useRef(null);
    const [isGenerating, setIsGenerating] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);

    // Get empId, month, year from location state
    const { empId, month, year } = location.state || {};

    useEffect(() => {
        const fetchSalaryData = async () => {
            if (!empId || !month || !year) {
                setError('Missing required data');
                setIsLoading(false);
                return;
            }

            try {
                setIsLoading(true);
                const token = localStorage.getItem("token");

                if (!token) {
                    toast.error("Authentication token not found. Please login again.");
                    setError('Authentication failed');
                    setIsLoading(false);
                    return;
                }

                const response = await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/api/v1/salary/slip/employee/${empId}?year=${year}&month=${month}`,
                    {
                        headers: {
                            'Accept': 'application/json',
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                console.log('API Response:', response.data);

                if (response.data && response.data.length > 0) {
                    const employeeData = response.data[0];

                    // Map API data to EXACT labels shown in the image
                    const pdfData = {
                        employeeNo: employeeData.empId,
                        employeeName: employeeData.employeeName,
                        designation: employeeData.designation,
                        dateOfJoining: employeeData.dateOfJoining,
                        location: employeeData.location || 'Pune',
                        month: getMonthName(month),
                        year: year,
                        companyName: "RAK SOFTECH PVT. LTD.",
                        attendance: {
                            workingDays: employeeData.totalDaysInMonth,
                            presentDays: employeeData.payableDays,
                            leaveWithPay: employeeData.leaveWithPay,
                            leaveWithoutPay: employeeData.leaveWithoutPay
                        },
                        earnings: [],
                        deductions: [],
                        totalEarnings: employeeData.totalEarning,
                        totalDeductions: employeeData.totalDeduction,
                        netSalary: employeeData.netSalary
                    };
/*
                    // Map items to EXACT labels shown in the image
                    if (employeeData.items && Array.isArray(employeeData.items)) {
                        const earnings = employeeData.items.filter(item => item.componentType === "EARNING");
                        const deductions = employeeData.items.filter(item => item.componentType === "DEDUCTION");

                        // Map earnings with EXACT labels from your image
                        pdfData.earnings = earnings.map(item => {
                            let label = item.componentName;
                            // Convert component names to match the image labels
                            switch (item.componentName) {
                                case 'BASIC':
                                    label = 'Basic Pay';
                                    break;
                                case 'HRA':
                                    label = 'HRA';
                                    break;
                                case 'CONVEYANCE':
                                    label = 'Conveyance Allowance';
                                    break;
                                case 'LTA':
                                    label = 'LTA';
                                    break;
                                case 'MEDICAL':
                                    label = 'Medical Allowances';
                                    break;
                                case 'SPECIAL_ALLOWANCE':
                                    label = 'Special Allowances';
                                    break;
                                case 'OTHER_REIMBURSEMENTS':
                                    label = 'Other Reimbursements';
                                    break;
                                default:
                                    label = item.componentName;
                            }
                            return {
                                label: label,
                                amount: item.actualAmount.toFixed(2)
                            };
                        });

                        // Map deductions with EXACT labels from your image
                        pdfData.deductions = deductions.map(item => {
                            let label = item.componentName;
                            switch (item.componentName) {
                                case 'PROFESSIONAL_TAX':
                                    label = 'Prof. Tax';
                                    break;
                                case 'ESIC':
                                    label = 'ESIC';
                                    break;
                                case 'PF_EMPLOYEE':
                                    label = 'P.F. Cont.';
                                    break;
                                case 'TDS':
                                    label = 'TDS';
                                    break;
                                case 'OTHER_DEDUCTION':
                                    label = 'Advance/Other Deductions';
                                    break;
                                default:
                                    label = item.componentName;
                            }
                            return {
                                label: label,
                                amount: item.actualAmount.toFixed(2)
                            };
                        });

                        // Ensure we have all rows, pad with empty strings
                        const maxLength = Math.max(pdfData.earnings.length, pdfData.deductions.length);
                        while (pdfData.earnings.length < maxLength) {
                            pdfData.earnings.push({ label: "", amount: "" });
                        }
                        while (pdfData.deductions.length < maxLength) {
                            pdfData.deductions.push({ label: "", amount: "" });
                        }
                    }
                        */
                       // Map items to EXACT labels shown in the image
if (employeeData.items && Array.isArray(employeeData.items)) {
    // Filter out PF_EMPLOYER from earnings
    const earnings = employeeData.items.filter(item => 
        item.componentType === "EARNING" && 
        item.componentName !== "PF_EMPLOYER"  // Exclude PF_EMPLOYER
    );
    
    const deductions = employeeData.items.filter(item => 
        item.componentType === "DEDUCTION"
    );

    // Map earnings with EXACT labels from your image
    pdfData.earnings = earnings.map(item => {
        let label = item.componentName;
        // Convert component names to match the image labels
        switch (item.componentName) {
            case 'BASIC':
                label = 'Basic Pay';
                break;
            case 'HRA':
                label = 'HRA';
                break;
            case 'CONVEYANCE':
                label = 'Conveyance Allowance';
                break;
            case 'LTA':
                label = 'LTA';
                break;
            case 'MEDICAL':
                label = 'Medical Allowances';
                break;
            case 'SPECIAL_ALLOWANCE':
                label = 'Special Allowances';
                break;
            case 'OTHER_REIMBURSEMENTS':
                label = 'Other Reimbursements';
                break;
            default:
                label = item.componentName;
        }
        return {
            label: label,
            amount: item.actualAmount.toFixed(2)
        };
    });

    // Map deductions with EXACT labels from your image
    pdfData.deductions = deductions.map(item => {
        let label = item.componentName;
        switch (item.componentName) {
            case 'PROFESSIONAL_TAX':
                label = 'Prof. Tax';
                break;
            case 'ESIC':
                label = 'ESIC';
                break;
            case 'PF_EMPLOYEE':
                label = 'P.F. Cont.';
                break;
            case 'TDS':
                label = 'TDS';
                break;
            case 'OTHER_DEDUCTION':
                label = 'Advance/Other Deductions';
                break;
            default:
                label = item.componentName;
        }
        return {
            label: label,
            amount: item.actualAmount.toFixed(2)
        };
    });

    // Ensure we have all rows, pad with empty strings
    const maxLength = Math.max(pdfData.earnings.length, pdfData.deductions.length);
    while (pdfData.earnings.length < maxLength) {
        pdfData.earnings.push({ label: "", amount: "" });
    }
    while (pdfData.deductions.length < maxLength) {
        pdfData.deductions.push({ label: "", amount: "" });
    }
}

                    setData(pdfData);
                } else {
                    setError('No salary data found for this employee');
                    toast.error('No salary data found for this employee');
                }
            } catch (error) {
                console.error('Error fetching salary data:', error);
                if (error.response) {
                    if (error.response.status === 404) {
                        setError('Salary data not found for this employee in the selected period');
                        toast.error('Salary data not found for this employee in the selected period');
                    } else if (error.response.status === 401) {
                        setError('Authentication failed. Please login again.');
                        toast.error('Authentication failed. Please login again.');
                    } else {
                        setError(error.response.data?.message || 'Failed to fetch salary data');
                        toast.error(error.response.data?.message || 'Failed to fetch salary data');
                    }
                } else if (error.request) {
                    setError('No response from server. Please check your connection.');
                    toast.error('No response from server. Please check your connection.');
                } else {
                    setError('An unexpected error occurred.');
                    toast.error('An unexpected error occurred.');
                }
            } finally {
                setIsLoading(false);
            }
        };

        fetchSalaryData();
    }, [empId, month, year]);

    // Helper function to get month name
    const getMonthName = (monthNumber) => {
        const months = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];
        return months[monthNumber - 1] || monthNumber;
    };

    const handleDownloadPDF = async () => {
        const element = salaryRef.current;
        if (!element) return;

        const downloadBtn = document.querySelector('#pdfDownloadBtn');
        const originalBtnText = downloadBtn?.innerHTML;
        if (downloadBtn) {
            downloadBtn.innerHTML = 'Generating PDF...';
            downloadBtn.disabled = true;
        }
        setIsGenerating(true);

        try {
            // Wait for images to load
            const images = element.querySelectorAll('img');
            await Promise.all(
                Array.from(images).map(img => {
                    if (img.complete) return Promise.resolve();
                    return new Promise(resolve => {
                        img.onload = resolve;
                        img.onerror = resolve;
                    });
                })
            );

            const canvas = await html2canvas(element, {
                scale: 3,
                useCORS: true,
                backgroundColor: '#ffffff',
                logging: false,
                width: 800,
                height: element.scrollHeight,
                onclone: (clonedDoc) => {
                    const clonedElement = clonedDoc.getElementById('salarySlipPdf');
                    if (clonedElement) {
                        clonedElement.style.border = '1px solid #000000';
                        const tables = clonedElement.querySelectorAll('table');
                        tables.forEach(table => {
                            table.style.border = '1px solid #000000';
                            table.style.borderCollapse = 'collapse';
                            const cells = table.querySelectorAll('td, th');
                            cells.forEach(cell => {
                                cell.style.border = '1px solid #000000';
                            });
                        });
                        const innerWrapper = clonedElement.querySelector('[style*="border: 1px solid"]');
                        if (innerWrapper) {
                            innerWrapper.style.border = '1px solid #000000';
                        }
                    }
                }
            });

            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: 'a4'
            });

            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();

            const imgWidth = pdfWidth;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            let heightLeft = imgHeight;
            let position = 0;

            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pdfHeight;

            while (heightLeft > 0) {
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                heightLeft -= pdfHeight;
            }

            pdf.save(`Salary_Slip_${data.employeeNo}_${data.month}_${data.year}.pdf`);
            toast.success('PDF downloaded successfully!');

        } catch (error) {
            console.error('PDF generation error:', error);
            toast.error('Error generating PDF. Please try again.');
        } finally {
            if (downloadBtn) {
                downloadBtn.innerHTML = originalBtnText;
                downloadBtn.disabled = false;
            }
            setIsGenerating(false);
        }
    };

    const handleBack = () => {
        navigate(-1);
    };

    // Show loading state
    if (isLoading) {
        return (
            <Layout>
                <div className="bg-light min-vh-100 py-4">
                    <div className="container text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-3">Loading salary details...</p>
                    </div>
                </div>
            </Layout>
        );
    }

    // Show error state
    if (error || !data) {
        return (
            <Layout>
                <div className="bg-light min-vh-100 py-4">
                    <div className="container text-center">
                        <h4>Error Loading Salary Data</h4>
                        <p className="text-danger">{error || 'No data available'}</p>
                        <button className="btn btn-primary mt-3" onClick={handleBack}>
                            Go Back
                        </button>
                    </div>
                </div>
            </Layout>
        );
    }

    // Render PDF content (SAME AS YOUR ORIGINAL CODE)
    return (
        <Layout>
            <div className="bg-light min-vh-100 py-4">
                <div className="container">
                    <div className="d-flex justify-content-between align-items-center mb-4 no-print">
                        <button className="btn btn-secondary" onClick={handleBack} disabled={isGenerating}>
                            ← Back
                        </button>
                        <button
                            id="pdfDownloadBtn"
                            className="btn btn-primary"
                            onClick={handleDownloadPDF}
                            disabled={isGenerating}
                            style={{ backgroundColor: '#1a3a5c', borderColor: '#1a3a5c' }}
                        >
                            {isGenerating ? 'Generating...' : '⬇ Download PDF'}
                        </button>
                    </div>

                    <div
                        ref={salaryRef}
                        id="salarySlipPdf"
                        style={{
                            width: '800px',
                            margin: '0 auto',
                            background: '#ffffff',
                            fontFamily: 'Arial, sans-serif',
                            padding: '35px 45px 25px 45px',
                        }}
                    >
                        {/* Main Wrapper with Border */}
                        <div style={{
                            border: '1px solid #000000',
                            padding: '40px',
                            backgroundColor: '#ffffff',
                        }}>

                            {/* Header Section */}
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                marginBottom: '25px',
                                borderBottom: '2px solid #000000',
                                paddingBottom: '15px',
                            }}>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-start',
                                    flexShrink: 0,
                                    marginRight: '20px',
                                }}>
                                    <img
                                        src={logo}
                                        alt="Company Logo"
                                        style={{
                                            width: '140px',
                                            height: '90px',
                                            objectFit: 'contain',
                                            display: 'block',
                                        }}
                                        crossOrigin="anonymous"
                                    />
                                    <div style={{
                                        fontSize: '8px',
                                        color: '#666',
                                        letterSpacing: '0.2px',
                                        whiteSpace: 'nowrap',
                                    }}>
                                        ISO/IEC 2700:2013  |  ISO/IGC 9001:2015
                                    </div>
                                </div>

                                <div>
                                    <div style={{
                                        fontSize: '22px',
                                        fontWeight: 'bold',
                                        letterSpacing: '1px',
                                        color: '#000000',
                                    }}>
                                        {data.companyName || 'RAK SOFTECH PVT. LTD.'}
                                    </div>

                                    <div style={{
                                        fontSize: '10px',
                                        color: '#666',
                                    }}>
                                        <div>Address : 3rd & 4th Floor, Mayuri Plaza, Above SBI Bank,</div>
                                        <div>Dange-Chowk, Near Bhoir Hospital, Chinchwad- Pune-</div>
                                        <div>411033 Branch : Pune, Noida, Nagpur</div>
                                        <div>
                                            Mobile : +91 9850898450 <span style={{ color: '#ccc' }}>|</span> Email : hr@raksoftech.com
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Pay Slip Title */}
                            <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                                <div style={{ fontSize: '20px', fontWeight: '500px' }}>
                                    SALARY SLIP
                                </div>
                            </div>

                            {/* Employee Details */}
                            <div style={{ marginBottom: '10px', fontSize: '13px' }}>
                                <div style={{ display: 'flex', marginBottom: '4px' }}>
                                    <div style={{ fontWeight: 'bold', width: '170px' }}>Employee Name</div>
                                    <div style={{ width: '200px' }}>{data.employeeName}</div>
                                    <div style={{ fontWeight: 'bold', width: '120px' }}>Employee Id</div>
                                    <div>{data.employeeNo}</div>
                                </div>
                                <div style={{ display: 'flex', marginBottom: '4px' }}>
                                    <div style={{ fontWeight: 'bold', width: '170px' }}>Designation</div>
                                    <div style={{ width: '200px' }}>{data.designation}</div>
                                    <div style={{ fontWeight: 'bold', width: '120px' }}>Date Of Joining</div>
                                    <div>{data.dateOfJoining}</div>
                                </div>
                                <div style={{ display: 'flex' }}>
                                    <div style={{ fontWeight: 'bold', width: '170px' }}>Location</div>
                                    <div style={{ width: '200px' }}>{data.location}</div>
                                    <div style={{ fontWeight: 'bold', width: '120px' }}>Pay Period</div>
                                    <div>{data.month},{data.year}</div>
                                </div>
                            </div>

                            {/* Attendance Table */}
                            <div style={{ marginTop: '40px', marginBottom: '15px' }}>
                                <table style={{
                                    width: '100%',
                                    borderCollapse: 'collapse',
                                    border: '1px solid #000000'
                                }}>
                                    <thead style={{ backgroundColor: 'white' }}>
                                        <tr>
                                            <th style={{
                                                border: '1px solid #000000',
                                                padding: '5px 8px',
                                                textAlign: 'left',
                                                fontWeight: 'bold',
                                                fontSize: '13px'
                                            }}>
                                                Attendance Details
                                            </th>
                                            <th style={{
                                                border: '1px solid #000000',
                                                padding: '5px 8px',
                                                textAlign: 'left',
                                                fontWeight: 'bold',
                                                fontSize: '13px'
                                            }}>
                                                Value
                                            </th>
                                            <th style={{
                                                border: '1px solid #000000',
                                                padding: '5px 8px',
                                                textAlign: 'left',
                                                fontWeight: 'bold',
                                                fontSize: '13px'
                                            }}>
                                            </th>
                                            <th style={{
                                                border: '1px solid #000000',
                                                padding: '5px 8px',
                                                textAlign: 'left',
                                                fontWeight: 'bold',
                                                fontSize: '13px'
                                            }}>
                                                Value
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td style={{ border: '1px solid #000000', padding: '5px 8px', fontSize: '13px' }}>Total Working Days</td>
                                            <td style={{ border: '1px solid #000000', padding: '5px 8px', fontSize: '13px' }}>{data.attendance.workingDays}</td>
                                            <td style={{ border: '1px solid #000000', padding: '5px 8px', fontSize: '13px' }}>Paid Leave</td>
                                            <td style={{ border: '1px solid #000000', padding: '5px 8px', fontSize: '13px' }}>{data.attendance.leaveWithPay}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ border: '1px solid #000000', padding: '5px 8px', fontSize: '13px' }}>Payable Days</td>
                                            <td style={{ border: '1px solid #000000', padding: '5px 8px', fontSize: '13px' }}>{data.attendance.presentDays}</td>
                                            <td style={{ border: '1px solid #000000', padding: '5px 8px', fontSize: '13px' }}>Unpaid Leave</td>
                                            <td style={{ border: '1px solid #000000', padding: '5px 8px', fontSize: '13px' }}>{data.attendance.leaveWithoutPay}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            {/* Earnings and Deductions Table */}
                            <div style={{ marginBottom: '15px', marginTop: '40px' }}>
                                <table style={{
                                    width: '100%',
                                    borderCollapse: 'collapse',
                                    border: '1px solid #000000'
                                }}>
                                    <thead style={{ backgroundColor: 'white' }}>
                                        <tr>
                                            <th style={{
                                                border: '1px solid #000000',
                                                padding: '5px 8px',
                                                textAlign: 'left',
                                                fontWeight: 'bold',
                                                fontSize: '13px'
                                            }}>
                                                Earnings
                                            </th>
                                            <th style={{
                                                border: '1px solid #000000',
                                                padding: '5px 8px',
                                                textAlign: 'right',
                                                fontWeight: 'bold',
                                                fontSize: '13px'
                                            }}>
                                                Amount
                                            </th>
                                            <th style={{
                                                border: '1px solid #000000',
                                                padding: '5px 8px',
                                                textAlign: 'left',
                                                fontWeight: 'bold',
                                                fontSize: '13px'
                                            }}>
                                                Deductions
                                            </th>
                                            <th style={{
                                                border: '1px solid #000000',
                                                padding: '5px 8px',
                                                textAlign: 'right',
                                                fontWeight: 'bold',
                                                fontSize: '13px'
                                            }}>
                                                Amount
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.earnings.map((earning, index) => (
                                            <tr key={index}>
                                                <td style={{ border: '1px solid #000000', padding: '4px 8px', fontSize: '13px' }}>
                                                    {earning.label}
                                                </td>
                                                <td style={{ border: '1px solid #000000', padding: '4px 8px', textAlign: 'right', fontSize: '13px' }}>
                                                    {earning.amount}
                                                </td>
                                                <td style={{ border: '1px solid #000000', padding: '4px 8px', fontSize: '13px' }}>
                                                    {data.deductions[index]?.label || ''}
                                                </td>
                                                <td style={{ border: '1px solid #000000', padding: '4px 8px', textAlign: 'right', fontSize: '13px' }}>
                                                    {data.deductions[index]?.amount || ''}
                                                </td>
                                            </tr>
                                        ))}
                                        <tr>
                                            <td style={{
                                                border: '1px solid #000000',
                                                padding: '5px 8px',
                                                fontWeight: 'bold',
                                                fontSize: '13px'
                                            }}>
                                                Total Earnings
                                            </td>
                                            <td style={{
                                                border: '1px solid #000000',
                                                padding: '5px 8px',
                                                textAlign: 'right',
                                                fontWeight: 'bold',
                                                fontSize: '13px'
                                            }}>
                                                {data.totalEarnings.toFixed(2)}
                                            </td>
                                            <td style={{
                                                border: '1px solid #000000',
                                                padding: '5px 8px',
                                                fontWeight: 'bold',
                                                fontSize: '13px'
                                            }}>
                                                Total Deductions
                                            </td>
                                            <td style={{
                                                border: '1px solid #000000',
                                                padding: '5px 8px',
                                                textAlign: 'right',
                                                fontWeight: 'bold',
                                                fontSize: '13px'
                                            }}>
                                                {data.totalDeductions.toFixed(2)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{
                                                border: '1px solid #000000',
                                                padding: '4px 8px',
                                                fontSize: '13px'
                                            }}></td>
                                            <td style={{
                                                border: '1px solid #000000',
                                                padding: '4px 8px',
                                                textAlign: 'right',
                                                fontSize: '13px'
                                            }}></td>
                                            <td style={{
                                                border: '1px solid #000000',
                                                padding: '4px 8px',
                                                fontWeight: 'bold',
                                                fontSize: '13px'
                                            }}>
                                                Net Salary
                                            </td>
                                            <td style={{
                                                border: '1px solid #000000',
                                                padding: '4px 8px',
                                                textAlign: 'right',
                                                fontWeight: 'bold',
                                                fontSize: '13px'
                                            }}>
                                                {data.netSalary.toFixed(2)}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            {/* Footer */}
                            <div style={{
                                textAlign: 'center',
                                paddingTop: '10px',
                                borderTop: '1px solid #cccccc',
                                marginTop: '10px'
                            }}>
                                <div style={{ fontSize: '11px', color: '#666666', fontStyle: 'italic' }}>
                                    This is a computer generated payslip and does not requires a signature
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <style>
                {`
                    @media print {
                        .no-print {
                            display: none !important;
                        }
                        #salarySlipPdf {
                            border: none !important;
                            padding: 35px 45px 25px 45px !important;
                        }
                    }
                    #salarySlipPdf table {
                        border: 1px solid #000000 !important;
                        border-collapse: collapse !important;
                    }
                    #salarySlipPdf td,
                    #salarySlipPdf th {
                        border: 1px solid #000000 !important;
                    }
                    #salarySlipPdf > div {
                        border: 1px solid #000000 !important;
                    }
                `}
            </style>
        </Layout>
    );
};

export default SalarySlipPdf;